// Flow types automatically removed

import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { MatchmakerIcon } from '../../shared/MatchmakerIcon/MatchmakerIcon.tsx';
import { setMatchmakerReferrer } from '../../shared/helpers/matchmakerReferrer.ts';
import styles from './styles/InteriorsLandingMatchmakerBanner.scss';
export function InteriorsLandingMatchmakerBanner() {
    return (
        <div className={styles.wrapper} data-tn="interiors-landing-matchmaker-banner">
            <div className="main-content-resp">
                <div className={styles.innerWrapper}>
                    <div className={styles.header} data-tn="abt-interiors-header">
                        <FormattedMessage
                            id="abt.interiorsLanding.matchmakerBannerHeader"
                            defaultMessage="Looking for an interior designer?"
                        />
                    </div>

                    <div className={styles.content} data-tn="abt-interiors-content">
                        <FormattedMessage
                            id="abt.interiorsLanding.matchmakerBannerContent"
                            defaultMessage="With our free service, Designer Connection, we'll recommend designers based on your style and needs."
                        />
                    </div>

                    <div className={styles.ctaWrapper}>
                        <Button
                            className={styles.matchmakerCta}
                            href="/trade/designer-connection/"
                            dataTn="abt-interiors-matchmaker-cta"
                            size="medium"
                            onClick={() => setMatchmakerReferrer('banner - designers landing')}
                        >
                            <FormattedMessage
                                id="abt.interiorsLanding.matchmakerBannerCta"
                                defaultMessage="Try Designer Connection"
                            />
                        </Button>

                        <div className={styles.matchmakerIconContainer}>
                            <MatchmakerIcon
                                wrapperClass={styles.svgWrapper}
                                personClass={styles.person}
                                professionalClass={styles.professional}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
